import styles from "./SliderTimeMarkerStyles.css";

export { default } from "./SliderTimeMarker";

export const heightDefinitionClassName = styles.heightDefinition;
export const widthDefinitionClassName = styles.widthDefinition;
